
import { Link } from 'react-router-dom';

import './App.css';
import { useState, useRef, useEffect, useContext } from "react";
import Venues from './Venues';
import { LocationContext } from './locationContext';


function Home() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [phone, setPhone] = useState("");
  const [showCoupon, setShowCoupon] = useState(false);
  const [selected, setSelected] = useState("#home");

  const heroImages = [
    "/images/Component 29.png",
    "/images/Component 30.png",
    "/images/Component 31.png",
    "/images/Component 32.png",
  ];


  const [heroIndex, setHeroIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setHeroIndex((prev) => (prev + 1) % heroImages.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const couponCode = "MEGA50";
  const [isOpen, setIsOpen] = useState(false);
  const modalRef = useRef(null);

  const handleClick = (section) => {
    setSelected(section);
    setMenuOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phone.trim() !== "") {
      setShowCoupon(true);
    }
  };

  const closePopup = () => {
    setPopupVisible(false);
    setPhone("");
    setShowCoupon(false);
  };

  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      const id = hash.replace("", "");
      const el = document.getElementById(id);

      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 300);
      }
    }
  }, []);

  // Handle Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  // Prevent background scroll
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  // Handle click outside modal
  const handleClickOutside = (e) => {
    if (e.target === modalRef.current) {
      setIsOpen(false);
    }
  };

  const { locations } = useContext(LocationContext);
  console.log("Loc1 data:", locations);

  return (
    <>
      <header className="header">
        <nav className="nav-container">
        <div className="logo-container">
  <Link to="/" className="logo-wrapper">
    <div className="logo-circle">
      <img
        src="/logo.png"
        alt="India Fashion Bazaar"
        className="logo-image"
      />
    </div>

    <div className="logo-text">
      <h1 className="logo-title">
        INDIA <span>FASHION</span> BAZAAR
      </h1>
      <p className="logo-subtitle">
        Ritvik Enterprises
      </p>
    </div>
  </Link>
</div>

          {menuOpen && <div className="nav-overlay" onClick={() => setMenuOpen(false)}></div>}

          <div className="menu-toggle">
            <button className="menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? "✕" : "☰"}
            </button>
          </div>

          <ul className={`nav-menu ${menuOpen ? "active" : ""}`} onClick={(e) => e.stopPropagation()}>
            <li className="nav-item">
              <a href="#home" className={selected === "#home" ? "active-link" : ""} onClick={() => handleClick("#home")}>
                Home
              </a>
            </li>
            <li className="nav-item">
              <a href="#special" className={selected === "#special" ? "active-link" : ""} onClick={() => handleClick("#special")}>
                Special Offer
              </a>
            </li>
            <li className="nav-item dropdown card-dropdown">
              <span className="dropdown-title">Location ▾</span>

              <div className="card-menu">
                <a href="/location">🏙️ {locations.Loc1.address}</a>
                <a href="/location2">🌆 {locations.Loc2.address}</a>
                <a href="/location">🏰 {locations.Loc3.address}</a>
              </div>
            </li>

            <li className="nav-item">
              <a href="#collections" className={selected === "#collections" ? "active-link" : ""} onClick={() => handleClick("#collections")}>
                Collection
              </a>
            </li>
            <li className="nav-item">
              <a href="#footer" className={selected === "#footer" ? "active-link" : ""} onClick={() => handleClick("#footer")}>
                Contact
              </a>
            </li>
          </ul>

          <div className="mobile-menu-toggle" id="mobileToggle" onClick={() => setMenuOpen(!menuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </nav>
      </header>
      <main>
        <section className="hero" id="home">
          <img
            src={heroImages[heroIndex]}
            alt="Mega Fashion Exhibition"
            className="hero-bg"
            loading="eager"
            decoding="async"
          />

          <div className="hero-content">
            <h1>Unbelievable Prices. Undeniable Luxury.</h1>
            <p>High-end vibes. Everyday prices.</p>
            <a href="#collections" className="cta-button">
              Explore Collection
            </a>
          </div>
        </section>

        <section class="stats-section">
          <div
            className="stat-card"
            style={{ backgroundImage: `url('/images/Image Card (4).png')` }}
          >
            <h2>20+ Years of Industry Experience</h2>
            <p>A decade of trusted excellence in the exhibition industry.</p>
            <div class="progress"></div>
          </div>

          <div
            className="stat-card"
            style={{ backgroundImage: `url('/images/Image Card (5).png')` }}
          >
            <h2>10M+ Exhibition Visitors</h2>
            <p>Massive footfall showcasing our wide-reaching audience impact.</p>
            <div class="progress"></div>
          </div>

          <div
            className="stat-card"
            style={{ backgroundImage: `url('/images/Image Card (6).png')` }}
          >
            <h2>500+ Brands</h2>
            <p>Leading names from diverse sectors choose to exhibit with us.</p>
            <div class="progress"></div>
          </div>

          <div
            className="stat-card"
            style={{ backgroundImage: `url('/images/Image Card (7).png')` }}
          >
            <h2>10+ States</h2>
            <p>Our exhibitions span across 20+ states, ensuring national reach.</p>
            <div class="progress"></div>
          </div>
        </section>

        <section class="about-section">
          <div class="container">
            <div class="images1">
              <img src="/images/Group 26.png" alt="img1" />
            </div>

            <div class="about-content-wrapper">
              <h2 class="title">About the event</h2>
              <p class="description">
                <span class="highlight">Tech Event 2025</span> showcases groundbreaking innovations, featuring keynote talks,
                interactive workshops, and networking sessions for tech enthusiasts and industry leaders.
              </p>
            </div>
            <div class="images2"><img src="/images/image 6.png" alt="img2" /></div>
          </div>
        </section>

        <section class="imgsection">
          <div className="event-card" style={{ backgroundImage: "url('/images/Component 19.png')" }}>
            <div class="event-card spring-fashion">
              <div class="past-event-badge">Past Event</div>
              <div class="event-content">
                <h3 class="event-title">Spring Fashion Week 2024</h3>
                <p class="event-date">March 2024</p>
                <p class="event-description">Join us as we showcase of spring collections from top designers.</p>
              </div>
            </div>
          </div>
          <div className="event-card" style={{ backgroundImage: "url('/images/Frame 37759.png')" }}>
            <div class="past-event-badge">Past Event</div>
            <div class="event-content">
              <h3 class="event-title">Avant-Garde Summer</h3>
              <p class="event-date">June 2024</p>
              <p class="event-description">An exclusive preview of summer collections featuring cutting-edge designs.</p>
            </div>
          </div>

          <div className="event-card" style={{ backgroundImage: "url('/images/Frame 37760.png')" }}>

            <div class="past-event-badge">Past Event</div>
            <div class="event-content">
              <h3 class="event-title">Winter Collection</h3>
              <p class="event-date">March 2024</p>
              <p class="event-description">A stunning display of winter elegance from international designers.</p>
            </div>
          </div>

          <div className="event-card" style={{ backgroundImage: "url('/images/Frame 37761.png')" }}>
            <div class="past-event-badge">Past Event</div>
            <div class="event-content">
              <h3 class="event-title">Avant-Garde Summer</h3>
              <p class="event-date">June 2024</p>
              <p class="event-description">An exclusive preview of summer collections.</p>
            </div>
          </div>

          <div className="event-card" style={{ backgroundImage: "url('/images/Frame 37762.png')" }}>
            <div class="past-event-badge">Past Event</div>
            <div class="event-content">
              <h3 class="event-title">Fashion Week Highlights</h3>
              <p class="event-date">May 2024</p>
              <p class="event-description">The biggest and most memorable moments from fashion week.</p>
            </div>
          </div>

          <div className="event-card" style={{ backgroundImage: "url('/images/Frame 37763.png')" }}>
            <div class="past-event-badge">Past Event</div>
            <div class="event-content">
              <h3 class="event-title">Designer Showcase</h3>
              <p class="event-date">JUNE 2024</p>
              <p class="event-description">Discover new creations and bold fashion statements.</p>
            </div>
          </div>
        </section>

        <div class="container" id="special">
          <h1 class="main-title">Fashion Exhibition 2025</h1>

          <p class="subtitle" >
            Join us for the most anticipated fashion event of the year, featuring exclusive collection,<br />
            designers showcases, and special sales events.
          </p>

          <div class="features-container">
            <div class="feature-item" >
              <div class="icon-circle calendar">
                <img class="icon" src="/images/uil_calender.png" alt="Offer Icon" />
              </div>
              <h3 class="feature-title">Exhibition Dates</h3>
              <div class="feature-content">
                <div class="feature-date">21 to 25 January
                </div>
                <div>10:00 AM - 10:00 PM</div>
              </div>
            </div>

            <div class="feature-item">
              <div class="icon-circle offers">
                <img class="icon" src="/images/bxs_offer.png" alt="Offer Icon" />
              </div>
              <h3 class="feature-title">Special Offers</h3>
              <div class="feature-content">
                <div class="feature-date">Up to 90% Off</div>
                <div>Early Bird Discount</div>
              </div>
            </div>

            <div class="feature-item" >
              <div class="icon-circle location">
                <img class="icon" src="/images/tdesign_location.png" alt="Offer Icon" />
              </div>
              <h3 class="feature-title">Next Location</h3>
              <div class="feature-content">
                <div class="feature-date">Fashion Center</div>
                <Link to={"/location"}>
                  <div class="view-locations">View Locations</div>
                </Link>
              </div>
            </div>
          </div>


        </div>


        <section className="collections" id="collections">
          <div className="collections-header">
            <h2>Collections</h2>
            <a href="https://www.instagram.com/" className="instagram-btn">Follow on Instagram</a>
          </div>

          <div className="collections-grid">
            <div
              className="collection-card"
              style={{ backgroundImage: "url('/images/Reel.png')" }}
            >
              <div className="collection-info">
                <h3>Men’s Wear</h3>
                <p>50K VIEWS</p>
              </div>
            </div>

            <div
              className="collection-card"
              style={{ backgroundImage: "url('/images/Reel (1).png')" }}
            >
              <div className="collection-info">
                <h3>Gen Z Style</h3>
                <p>24K VIEWS</p>
              </div>
            </div>

            <div
              className="collection-card"
              style={{ backgroundImage: "url('/images/Reel (2).png')" }}
            >
              <div className="collection-info">
                <h3>Festival</h3>
                <p>26K VIEWS</p>
              </div>
            </div>

            <div
              className="collection-card"
              style={{ backgroundImage: "url('/images/Reel (3).png')" }}
            >
              <div className="collection-info">
                <h3>Friendship Club Edit</h3>
                <p>30K VIEWS</p>
              </div>
            </div>

            <div
              className="collection-card"
              style={{ backgroundImage: "url('/images/Reel (7).png')" }}
            >
              <div className="collection-info">
                <h3>Fun, casual styles made for moments with friends.</h3>
                <p>50K VIEWS</p>
              </div>
            </div>

            <div
              className="collection-card"
              style={{ backgroundImage: "url('/images/Reel (6).png')" }}
            >
              <div className="collection-info">
                <h3>Business Conference Lookbook</h3>
                <p>24K VIEWS</p>
              </div>
            </div>

            <div
              className="collection-card"
              style={{ backgroundImage: "url('/images/Reel (5).png')" }}
            >
              <div className="collection-info">
                <h3>Seasonal Highlights</h3>
                <p>26K VIEWS</p>
              </div>
            </div>

            <div
              className="collection-card"
              style={{ backgroundImage: "url('/images/Reel (4).png')" }}
            >
              <div className="collection-info">
                <h3>Everyday Luxe</h3>
                <p>30K VIEWS</p>
              </div>
            </div>
          </div>
        </section>

        <div class="container1">
          <div class="header1">
            <h1>Check our latest gallery</h1>
            <p>Team with all the tools they need to streamline your event planning process. Some top artists have gained global</p>
          </div>

          <div class="gallery">
            <img src="/images/Images.png" alt="galleryimg" />
          </div>
        </div>
        <div id='location'>
          {/* <Venues /> */}
        </div>
        <div class="container2">
          <div class="Visitors">
            <h1>What Our Visitors Say</h1>
            <p>Here from fashion enthusiasts, industry professionals, and style lovers who have experienced our exhibitions</p>
          </div>

          <div class="testimonials">
            <div class="testimonial-card card-1">
              {/* <div class="quote-marks">"</div> */}
              <div class="testimonial-content">
                I am very satisfied with the training given by XYZ Pvt. Ltd on Web Designing. During training, the faculty was able to clear my doubts regarding design process.
              </div>
              <div class="testimonial-footer">
                <div class="profile-image">
                  <img src="/images/Frame 37799.png" alt="Varsha" />
                </div>
                <div class="profile-info">
                  <h3>Varsha</h3>
                  <div class="stars">
                    <span class="star">★</span>
                    <span class="star">★</span>
                    <span class="star">★</span>
                    <span class="star">★</span>
                    <span class="star empty">★</span>
                  </div>
                </div>
              </div>
              {/* <div class="quote-marks bottom">"</div> */}
            </div>

            <div class="testimonial-card card-2">
              {/* <div class="quote-marks">"</div> */}
              <div class="testimonial-content">
                I am very satisfied with the training given by XYZ Pvt. Ltd on Web Designing. During training, the faculty was able to clear my doubts regarding design process.
              </div>
              <div class="testimonial-footer">
                <div class="profile-image">
                  <img src="/images/Frame 37799 (1).png" alt="Roshni" />
                </div>
                <div class="profile-info">
                  <h3>Roshni</h3>
                  <div class="stars">
                    <span class="star">★</span>
                    <span class="star">★</span>
                    <span class="star">★</span>
                    <span class="star">★</span>
                    <span class="star empty">★</span>
                  </div>
                </div>
              </div>
              {/* <div class="quote-marks bottom">"</div> */}
            </div>

            <div class="testimonial-card card-3">
              {/* <div class="quote-marks">"</div> */}
              <div class="testimonial-content">
                I am very satisfied with the training given by XYZ Pvt. Ltd on Web Designing. During training, the faculty was able to clear my doubts regarding design process.
              </div>
              <div class="testimonial-footer">
                <div class="profile-image">
                  <img src="/images/Frame 37799 (2).png" alt="Maya" />
                </div>
                <div class="profile-info">
                  <h3>Maya</h3>
                  <div class="stars">
                    <span class="star">★</span>
                    <span class="star">★</span>
                    <span class="star">★</span>
                    <span class="star">★</span>
                    <span class="star empty">★</span>
                  </div>
                </div>
              </div>
              {/* <div class="quote-marks bottom">"</div> */}
            </div>
          </div>
        </div>

        <a
          href="https://wa.me/91xxxxxxxxxx?text=Hi%20Mega%20Fashion%20team%2C%20I%27m%20interested%20in%20your%20collection."
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-float-button"
        >
          <img src="/images/WhatsApp.svg.webp" alt="WhatsApp" />
        </a>


        {isOpen && (
          <div></div>
        )}


        <footer className="footer" id="footer">
          <div className="footer-container">
            <div className="footer-column">
              <img src="/images/Rectangle 176.png" alt="Mega Fashion Logo" className="footer-logo" />
              <p>Since [Year], showcased across [Locations].</p>
              <p>Up to [Discount]% OFF on top brands & handloom styles.</p>
              <div className="contact-info">
                <p>
                  <img src="/images/Vector (2).png" alt="email" /> megafashionhandloomsale@gmail.com
                </p>
                <p>
                  <img src="/images/Vector (4).png" alt="address" /> SS-1382, Sector-H, LDA Colony, Kanpur Road, Lucknow, Uttar Pradesh, 226012
                  <br />

                </p>
                <p>
                  <img src="/images/Vector (3).png" alt="phone" /> +919869145830
                </p>
              </div>
            </div>

            <div className="footer-column1">
              <h3>Eventick</h3>
              <ul>
                <li>
                  <a href="#home">Home</a>
                </li>
                <li>
                  <a href="#special">Special offer</a>
                </li>
                <li>
                  <Link to={'/location'}>
                    Location
                  </Link>
                  {/* <a href="#location">Location</a> */}
                </li>
                <li>
                  <a href="#collections">Collection</a>
                </li>
                <li>
                  <a href="#footer">Contact</a>
                </li>
              </ul>
            </div>

            <div className="footer-column2">
              <h3>Stay In The Loop</h3>
              <p>Join our mailing list to stay in the loop with our newest for Event and concert</p>
            </div>
          </div>

          <div className="footer-socials">
            <a href="https://www.facebook.com/">
              <img src="/images/facebook.png" alt="Facebook" />
            </a>
            <a href="https://x.com/">
              <img src="/images/Square button.png" alt="X" />
            </a>
            <a href="https://in.linkedin.com/">
              <img src="/images/Group (2).png" alt="LinkedIn" />
            </a>
          </div>
        </footer>
      </main>
    </>
  );
}

export default Home;
